import { Card, Typography } from 'antd';
import React from 'react';
import { FileInfo } from '../../../generated';
import FilePreview from '../file-preview/file-preview';

export interface FilesSummaryProps {
  fileDetails: FileInfo[];
}

export const FilesSummary: React.FC<FilesSummaryProps> = (props) => {
  return (
    <Card>
      <Typography.Text style={{ fontSize: '20px' }}>Files</Typography.Text>
      <div
        className="flex space-x-6 gap-16"
        style={{
          maxWidth: '150%',
          flex: '1 1 auto',
          flexWrap: 'wrap',
          padding: '20px'
        }}
      >
        {props.fileDetails &&
          props.fileDetails
            ?.filter((file) => !file?.name?.endsWith('.json'))
            .map((file) => <FilePreview key={file?.name} fileUrl={file?.url || ''} fileName={file?.name?.split('/').pop() || ''} fileType={file?.type || ''} />)}
      </div>
    </Card>
  );
};
